import React, {useCallback} from "react";
import fillRef from "./fillRef";


export default function useCombineRef<T>(
  ...refs: ReadonlyArray<React.Ref<T> | undefined>
): React.RefCallback<T> {
  return useCallback((node: T) => {
    return refs.forEach((ref) => {
      if (ref) {
        fillRef(ref, node);
      }
    });
  }, refs);
}
